<!--
/**
* @name: List.vue
* @description: 推广公司管理列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入推广公司名称" block clearable v-model="para.name"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择销售渠道" block clearable v-model="para.channelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" block clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button @click="synchronizeMainDatas">同步主数据</y-button>
        <y-button icon="k-icon-add" @click="onAdd">新建</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="companyList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination
      :total="total"
      v-if="companyList && companyList.length"
      :current-page.sync="para.pageCurrent"
      :page-size.sync="para.pageSize"
      @page-change="onChangePageIndex"
    />
    <div class="popup_box">
      <k-popup bind="v-if" okText="保存" :title="popupTitle" :show.sync="isShowPopup" @after-ok="onSave">
        <div style="width: 650px;">
          <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
            <y-form-item title="销售渠道:" required>
              <k-select placeholder="请选择销售渠道" block clearable v-model="editPara.channelCode">
                <k-option
                  v-for="item in channelList"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                  :selected="editPara.channelCode == item.code"
                  >{{ item.name }}</k-option
                >
              </k-select>
            </y-form-item>
            <y-form-item title="推广公司ID:">
              <k-input placeholder="创建后自动生成" block disabled v-model="editPara.code"></k-input>
            </y-form-item>
            <y-form-item title="推广公司名称:" required>
              <k-input
                placeholder="请输入推广公司名称"
                v-model="editPara.name"
                v-validate="'required|minLength(2)|maxLength(20)'"
                block
                maxlength="20"
              ></k-input>
            </y-form-item>
            <y-form-item title="上级推广公司:">
              <k-select placeholder="请选择上级推广公司" block clearable v-model="editPara.superCode">
                <k-option
                  v-for="item in dataList"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                  :selected="editPara.superCode == item.code"
                  >{{ item.name }}</k-option
                >
              </k-select>
            </y-form-item>
            <y-form-item title="组织机构:">
              <k-select block clearable v-model="editPara.organizationId">
                <k-option
                  v-for="item in orgList"
                  :key="item.ocode"
                  :value="item.ocode"
                  :label="item.oname"
                  :selected="editPara.organizationId == item.ocode"
                  >{{ item.oname }}</k-option
                >
              </k-select>
            </y-form-item>
            <y-form-item title="联系人姓名:" required>
              <k-input placeholder="请输入联系人姓名" v-model="editPara.contactUser" block></k-input>
            </y-form-item>
            <y-form-item title="联系人电话:" required>
              <k-input placeholder="请输入联系人电话" v-model="editPara.contactPhone" block></k-input>
            </y-form-item>
            <!-- 通货功能相关改造 start -->
            <y-form-item title="供应商名称:">
              <k-input placeholder="请输入供应商名称，多个英文逗号隔开" v-model="supplierCompanyNameStr" block></k-input>
            </y-form-item>
            <!-- 通货功能相关改造 end -->
            <y-form-item title="状态:" required>
              <div>
                <k-radio v-model="editPara.status" value="1">启用</k-radio>
                <k-radio v-model="editPara.status" value="2">停用</k-radio>
              </div>
            </y-form-item>
          </y-form>
        </div>
      </k-popup>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_PAGELIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_ADD,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_UPDATACOMPANYBYMAINDATA,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_INFO,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_DELETE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_STATUS_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_ORGANIZATION_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST
} from '@/assets/modules/apiList';

const initPara = () => ({
  name: '',
  channelCode: '',
  status: '',
  pageCurrent: 1,
  pageSize: 15
});
const initEditPara = () => ({
  channelCode: '',
  name: '',
  organizationId: '',
  contactUser: '',
  contactPhone: '',
  status: '1',
  code: ''
});
export default {
  data() {
    return {
      isLoading: false,
      companyList: [],
      channelList: [],
      orgList: [],
      para: initPara(),
      editPara: initEditPara(),
      dataList: [],
      statusList: [
        { label: '启用', value: 1 },
        { label: '停用', value: 2 }
      ],
      total: 0,
      supplierCompanyNameStr: '', // 通货相关
      isEdit: false,
      isSaving: false,
      isShowPopup: false
    };
  },
  watch: {
    isShowPopup(v) {
      if (!v) {
        if (this.isEdit) {
          this.isEdit = false;
        }
        this.editPara = initEditPara();
        this.supplierCompanyNameStr = ''; // 通货相关
      }
      this.getOrgList();
      this.getList();
    }
  },
  computed: {
    popupTitle() {
      if (this.isEdit) {
        return '编辑推广公司信息';
      } else {
        return '新增推广公司信息';
      }
    }
  },
  methods: {
    synchronizeMainDatas() {
      const { tip } = this.$root;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_UPDATACOMPANYBYMAINDATA,
        para: {}
      })
        .then(() => {
          tip('操作成功');
        })
        .catch(() => {
          tip('操作失败，请重试');
        });
    },
    initColumns() {
      return [
        {
          name: '推广公司ID',
          field: 'code',
          style: {
            width: 80,
            textAlign: 'center'
          }
        },
        {
          name: '推广公司名称',
          field: 'name',
          style: {
            width: 200,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '销售渠道',
          field: 'channelName',
          style: {
            width: 100,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '组织机构',
          field: 'organizationName',
          style: {
            width: 150,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '联系人姓名',
          field: 'contactUser',
          style: {
            width: 80,
            textAlign: 'center'
          },
          customRender:row=>(
            <insensitive val={row.contactUser} isShowEye={false} type="name"></insensitive>
          )
        },
        {
          name: '联系人电话',
          field: 'contactPhone',
          style: {
            width: 80,
            textAlign: 'center'
          },
          customRender:row=>(
            <insensitive val={row.contactPhone} isShowEye={false}></insensitive>
          )
        },
        {
          name: '状态',
          field: '',
          style: {
            width: 80,
            textAlign: 'center'
          },
          customRender: row => (
            <k-switch
              checked={row.status}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          )
        },
        {
          name: '操作',
          field: 'action',
          style: { textAlign: 'center' },
          customRender: row => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            return <div>{editButton}</div>;
          }
        }
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getCompanyList();
    },
    onReset() {
      this.para = initPara();
      this.getCompanyList();
    },
    onEdit(row) {
      this.isShowPopup = true;
      this.editPara = JSON.parse(JSON.stringify(row));
      // 通货功能相关改造 start
      if (this.editPara.supplierCompanyNameList && this.editPara.supplierCompanyNameList.length > 0) {
        this.supplierCompanyNameStr = this.editPara.supplierCompanyNameList.join(',');
      }
      // 通货功能相关改造 start
      this.isEdit = true;
    },
    getCompanyList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_PAGELIST,
        para
      }).then(res => {
        this.companyList = res.pageList || [];
        this.total = res.total;
      });
    },
    // 推广公司列表不分页
    getList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {}
      }).then(res => {
        let dataList = [];
        if (res && res.length > 0) {
          res.forEach(item => {
            if (!item.superCode) {
              dataList.push(item);
            }
          });
        }
        this.dataList = dataList;
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {}
      }).then(res => {
        this.channelList = res || [];
      });
    },
    getOrgList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_ORGANIZATION_LIST,
        para: {}
      }).then(res => {
        this.orgList = res || [];
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getCompanyList();
    },
    onAdd() {
      this.isShowPopup = true;
    },
    onChangeStatus(row) {
      let { code, status } = row;
      this.$dialog({
        title: '提示',
        content: `是否确认${row.status == '1' ? '停用' : '启用'}该推广公司？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_STATUS_UPDATE,
            para: { code, status: status == '1' ? 2 : 1 }
          })
            .then(() => {
              this.isLoading = false;
              this.getCompanyList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    onSave() {
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (this.isEdit && !para.organizationId) {
        delete para.organizationName;
      }
      const { tip } = this.$root;
      para.supplierCompanyNameList = this.supplierCompanyNameStr.split(','); // 通货相关
      // 内容检查
      if (!para.channelCode) {
        return tip('请选择销售渠道');
      }
      if (para.name.replace(/\s*/, '').length < 1) {
        return tip('请输入推广公司名称');
      }
      if (!para.contactUser) {
        return tip('请输入联系人姓名');
      }
      if (!para.contactPhone) {
        return tip('请输入联系人电话');
      }
      if (!para.status) {
        return tip('请选择推广公司状态');
      }
      for (let i = 0; i < this.orgList.length; i++) {
        if (para.organizationId == this.orgList[i].ocode) {
          para.organizationName = this.orgList[i].oname;
          break;
        }
      }
      for (let i = 0; i < this.channelList.length; i++) {
        if (para.channelCode == this.channelList[i].code) {
          para.channelName = this.channelList[i].name;
          break;
        }
      }
      this.isSaving = true;
      this.isLoading = true;
      let api = NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_ADD;
      if (this.isEdit) {
        api = NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_UPDATE;
      }
      this.$fetch({
        api,
        para
      })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.isShowPopup = false;
          this.getCompanyList();
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    }
  },
  created() {
    this.getCompanyList();
    this.getChannelList();
  }
};
</script>

<style lang="postcss" module="css"></style>
